export const tableHeadConfig = [
  { id: 1, label: 'Location' },
  { id: 2, label: 'Sublocation' },
  { id: 3, label: 'Contained In' },
  { id: 4, label: 'Note' },
  { id: 5, label: 'Status' },
  { id: 6, label: 'Min QTY' },
  { id: 7, label: 'BAA', footnote: '[1]' },
  { id: 8, label: 'Current QTY' },
  { id: 9, label: '' }
];
